$(document).ready(function(){
  $(document).on('click','.outer_accordianbox h3', function(){
    var $this = $(this).closest('.outer_accordianbox');
    if (!$this.hasClass("display_show")) {
      $(".outer_accordianbox").removeClass("display_show");
    }
    $this.toggleClass("display_show");
  });
});



$('.rightheadre').on('click', function() {
  $('.rightheadre').toggleClass('open');
  $('body').toggleClass('openmenu');
});

$('.subscription_pucrchase').hide();
setInterval(function() {
$('.yotpo-radio-buy-once-container').on('click', function(){
   if ($('input.yotpo-radio-label-input').is(':checked') == true ) {
     $(this).addClass('yotpo-selected');
     $('.onetime_pucrchase').show();
     $('.subscription_pucrchase').hide(); 
  }  
});
$('.custom-image-swatches').on('click', function(){
     $('.onetime_pucrchase').show();
     $('.subscription_pucrchase').hide(); 
}); 
$('.yotpo-radio-subscription-container').on('click',function(){
   if ($('input.yotpo-radio-label-input').is(':checked') == true ) {
     $(this).addClass('yotpo-selected');
     $('.onetime_pucrchase').hide();
     $('.subscription_pucrchase').show();

     var pricenew = $('.custom-product-outer .product-form__input input[type=radio]:checked+label').find('.custom_pack_text .subscription_pucrchase').html();
       console.log(pricenew);
   }  
});
},100);
// end script hide-show subuscription discount

$(".disclosure__button").click(function(){
  $(".disclosure__list-wrapper").toggleClass("disclosure_active");
});

// Attach a click event handler to the "span.close-popup" element
$("span.close-popup").on("click", function() {
    // Find the parent section element with the class "newsletter-popup" and add the "hidepopup" class to it
    $(this).closest("section.newsletter-popup").addClass("hidepopup");
});
// cokkie set for newsletter
  // Function to show the newsletter popup
  function showPopup() {
    $("#shopify-section-newsletter-popup").show();

    // Set the cookie to expire in 20 minutes
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (1440 * 60 * 1000)); // 20 minutes
    document.cookie = "newsletter_popup_displayed=true; expires=" + expirationDate.toUTCString();
  }

  // Function to hide the newsletter popup
  function hidePopup() {
    $("#shopify-section-newsletter-popup").hide();
  }

  // Check if the cookie is already set
  if (document.cookie.indexOf("newsletter_popup_displayed=true") === -1) {
    showPopup();

    // Set a timer to hide the popup after 20 minutes
    setTimeout(hidePopup, 20 * 60 * 1000); // 20 minutes in milliseconds
  }
// End cokkie setup
// custom banner to hide the video
// $('.outer-playimage').on('click', function() {
//  $(this).addClass('hidebanner');
//  $('.trigger-video').trigger('click');
// });
$('video').click(function(){
	// Toggle Magic Here
    this[this.paused ? 'play' : 'pause']();
});

// custom accordian head funcation
$('.accordian_head').on('click',function(){
   $(this).next().slideToggle('hide_show_details') 
});

// accordian details


//// on click to review scroll down to the review section
// Listen for click events on elements with class "yotpo-reviews-star-ratings-widget"
var intervalId; // Store the interval ID
      intervalId = setInterval(function() {
        $('.yotpo-reviews-star-ratings-widget').on('click', function() {
          var position = $('.review_custom_ing').offset().top;
          $('html, body').animate({ scrollTop: position }, 1000);
        });
      }, 1000); // 1000 milliseconds = 1 second
//// End scrolling function

// custom product media slider
$('.product_media_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true
});

// Banner slider
$('.Banner-Slider').slick({
    dots: true,
    arrows:false,
    infinite: false,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 1000,
    autoplay: false,
    autoplaySpeed: 800,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  



  // Recipes slider js //

  $('.recipes-slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    autoplay:true,
    speed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

// custom product review slider 
$('.slick-product-review').slick({
  dots: true,
    arrows:false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
//   $('.sliderView').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     fade: true,
//     speed: 500,
//     loop: true,
//     arrows: false,
//     dots:true,
//     asNavFor: '.thumbnail-slick-slider'
// });


$('.thumbnail-slick-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    vertical: true,
    //asNavFor: '.sliderView',
    dots: false,
    loop: true,
    arrows: false,
    focusOnSelect: true,
    verticalSwiping: false,
    speed: 500,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                vertical: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
                vertical: false,
               slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 580,
            settings: {
                vertical: false,
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 380,
            settings: {
                vertical: true,
                slidesToShow: 2,
            }
        }
    ]
});

// Localization currency selector
$('#localization-selector').on('change', function() {
  $('.change-currencycode').trigger('click');
});

// accordion js //
var CFAccordion=function(t,e){"use strict";this.el=document.getElementById(t),this.elems=[],this.cons=[],this.heightArray=[],this.openArray=[],this.mode=e,this.init()};CFAccordion.prototype.init=function(){"use strict";this.elems=this.getLevelElements(this.el,"h3");for(var t=0;t<this.elems.length;t++)this.setListener(t);this.cons=this.getLevelElements(this.el,"div");for(var e=0;e<this.cons.length;e++){this.heightArray.push(this.cons[e].offsetHeight);try{this.cons[e].style.height="0px"}catch(t){this.cons[e].style.setProperty("height","0px")}}},CFAccordion.prototype.setListener=function(t){"use strict";var e=this;var s;this.elems[t].addEventListener("click",(function(){e.openTab(t)}),!1)},CFAccordion.prototype.openTab=function(t){"use strict";var e=this;if(-1===this.openArray.indexOf(t)){if("dynamic"===this.mode)for(var s=0;s<this.cons.length;s++){try{this.cons[s].style.height="0px"}catch(t){this.cons[s].style.setProperty("height","0px")}this.elems[s].className="",this.openArray.splice(this.openArray.indexOf(t),1)}try{this.cons[t].style.height=this.heightArray[t]+"px"}catch(e){this.cons[t].style.setProperty("height",this.heightArray[t]+"px")}this.elems[t].className="opentab",this.openArray.push(t)}else{try{this.cons[t].style.height="0px"}catch(e){this.cons[t].style.setProperty("height","0px")}this.elems[t].className="",this.openArray.splice(this.openArray.indexOf(t),1)}},CFAccordion.prototype.initialOpen=function(t){"use strict";var e;this.openTab(t)},CFAccordion.prototype.collapseAll=function(t){"use strict";for(var e=0;e<this.cons.length;e++){try{this.cons[e].style.height="0px"}catch(t){this.cons[e].style.setProperty("height","0px")}this.elems[e].className="",this.openArray.splice(this.heightArray[t]+"px")}},CFAccordion.prototype.expandAll=function(){"use strict";for(var t=0;t<this.cons.length;t++){try{this.cons[t].style.height=this.heightArray[t]+"px"}catch(e){this.cons[t].style.setProperty("height",this.heightArray[t]+"px")}this.elems[t].className="opentab",this.openArray.push(t)}},CFAccordion.prototype.getLevelElements=function(t,e){"use strict";var s=t.getElementsByTagName(e);var i=[];for(var h=0;h<s.length;h++)s[h].parentNode===t&&i.push(s[h]);return i};
var myAccordion = new CFAccordion("myAccordion", 'dynamic');
    myAccordion.initialOpen(0);
//# sourceMappingURL=/s/files/1/0216/7720/t/489/assets/CFAccordion.js.map?v=9299452596874645478


// Get all elements with the 'hoverButton' class
const buttons1 = document.getElementsByClassName('moveButton');
// Loop through each button to attach event listeners
for (const button of buttons1) {
  button.addEventListener('mouseover', () => {
    const randomLeft = Math.floor(Math.random() * 30);    // Random left position from 0 to 30
    const randomBottom = Math.floor(Math.random() * 30);  // Random bottom position from 0 to 30
    const randomRight = Math.floor(Math.random() * 30);   // Random right position from 0 to 30
    const randomTop = Math.floor(Math.random() * 30);     // Random top position from 0 to 30

    button.style.transform = `translate3d(${randomLeft}px, ${randomTop}px, 0)`;
  });

  button.addEventListener('mouseout', () => {
    // Reset the position to the original state
    button.style.transform = 'translate3d(0, 0, 0)';
  });
}

// custom scroll to review 
$('.yotpo-reviews-star-ratings-widget').on('click', function() {
    scrollToReviewSection();
    // Repeat the scroll every 1 second using setInterval
    setInterval(function() {
        scrollToReviewSection();
    }, 1000);
});

function scrollToReviewSection() {
    var targetSection = $(".section.review_custom_ing");
    if (targetSection.length > 0) {
        $("html, body").animate({
            scrollTop: targetSection.offset().top
        }, 1000); // You can adjust the animation duration as needed
    }
}



     
